export default {
  filters: {
    toCurrency(amount) {
      if (!amount || amount < 0) {
        return "R$ n/a";
      }

      return `R$ ${(amount / 100).toFixed(2).replace(".", ",")}`;
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins/generic/currencyMixin.js